$(function() {
  $('#btn-skip').on('click', function () {
    // Submit empty form and "skips" the page
    $('#booking-additional-submit')[0].firstElementChild.click();
  });
});
